import {
  ArrowRightLeftIcon,
  BadgeDollarSignIcon,
  ClipboardCheckIcon,
  FileTextIcon,
  LinkIcon,
  ScaleIcon,
  SearchIcon,
  ShoppingCartIcon,
  SparklesIcon,
  TrendingUpIcon,
  UsersIcon,
} from 'lucide-react'

const SECTION_ICONS: Record<string, React.ElementType> = {
  summary_overview: FileTextIcon,
  income_analysis: TrendingUpIcon,
  transaction_analysis: SearchIcon,
  spending_pattern_analysis: ShoppingCartIcon,
  related_party_transaction_analysis: UsersIcon,
  cash_flow_analysis: BadgeDollarSignIcon,
  asset_tracing: SparklesIcon,
  transfer_pattern_analysis: ArrowRightLeftIcon,
  lifestyle_and_standard_of_living: ScaleIcon,
  means_test_and_eligibility: ClipboardCheckIcon,
  forensic_timeline_analysis: LinkIcon,
  conclusion_and_recommendations: FileTextIcon,
}

export const SectionIcon = ({ sectionKey }: { sectionKey: string }) => {
  const Icon = SECTION_ICONS[sectionKey] ?? FileTextIcon
  return (
    <div className="rounded-md bg-brand/10 p-1 shrink-0">
      <Icon className="h-3.5 w-3.5 text-brand" />
    </div>
  )
}
